<template>
    <div>
        <div v-if="runners.length" class="grid grid-cols-2 sm:mb-4">
            <div class="flex-shrink-1 justify-start col-span-2 md:col-span-1 hidden md:block">
                <div class="flex transition duration-500 ease-in-out dark:text-white">
                    <h4 class="font-semibold mr-2">Total Stake:</h4> 1 Token
                </div>
                <div class="flex transition duration-500 ease-in-out dark:text-white">
                    <span class="inline-block"><h4 class="font-semibold mr-2">Potential Daily Winnings:</h4> {{ formatter.format($page.props.racingstars.dailyJackpot / 100) }}</span>
                    
                    <span class="inline-block"><h4 class="font-semibold mr-2 ml-2">Potential Weekly Winnings:</h4> {{ formatter.format($page.props.racingstars.weeklyJackpot / 100) }}</span>
                </div>
            </div>
            <div class="col-span-2 md:hidden dark:text-white mb-2 text-center">
                <h4 class="font-semibold mr-2">Total Stake: <span class="font-light">1 Token</span></h4>
            </div>
            <div class="flex justify-end col-span-2 mt-2 md:col-span-1 md:mt-0">
                <tw-button class="w-full md:w-auto disabled:opacity-50 disabled:cursor-not-allowed" :disabled="bettingDisabled" @click="showPlaceBetModal = true">Place Bet</tw-button>
            </div>
        </div>
        <div v-if="runners.length" class="grid grid-cols-1">
            <div v-for="(runner, key) in runners" :key="key" class="relative border-t border-gray-300 bg-white px-6 py-5 flex items-center space-x-3 hover:border-gray-300 dark:bg-gray-900 dark:border-gray-600 dark:hover:border-gray-700 transition duration-500 ease-in-out">
                <div class="shrink-0">
                    <p class="text-sm font-semibold text-gray-900 flex justify-center items-center dark:text-white transition duration-500 ease-in-out">
                        {{ runner.start_number }}
                    </p>
                    <p v-if="runner.draw" class="text-sm text-gray-900 flex justify-center items-center dark:text-white transition duration-500 ease-in-out">
                        ({{ runner.draw }})
                    </p>
                </div>
                <div class="shrink-0 dark:rounded-full dark:bg-white dark:p-2 dark:w-10 dark:h-10 dark:flex dark:items-center dark:justify-center">
                    <img class="w-10" :src="runner.silk_image_path" alt="" />
                </div>
                <div class="flex-1 min-w-0">
                    <p class="text-sm font-medium text-gray-900 dark:text-white transition duration-500 ease-in-out truncate" v-if="runner.horse">
                        {{ runner.horse.name }}
                    </p>
                    <p class="hidden text-sm text-gray-500 truncate md:inline-block pr-4 dark:text-white transition duration-500 ease-in-out truncate" v-if="runner.horse">
                        Trainer: {{ runner.horse.trainer ? runner.horse.trainer.name : '' }}
                    </p>
                    <p class="hidden text-sm text-gray-500 truncate md:inline-block dark:text-white transition duration-500 ease-in-out truncate" v-if="runner.jockey">
                        Jockey: {{ runner.jockey.name }}
                    </p>
                    <p class="hidden text-sm text-gray-500 truncate md:inline-block dark:text-white transition duration-500 ease-in-out truncate" v-else>
                        Jockey: <strong>Reserve</strong>
                    </p>
                </div>
                <div class="shrink-0">
                    <p class="text-sm font-semibold text-gray-900 flex justify-left items-center dark:text-white transition duration-500 ease-in-out">
                        {{ runner.forecast_odds }}
                    </p>
                </div>

                <div class="shrink-0">
                    <div class="h-10 w-10 flex items-center justify-center rounded-full border-2 border-gray-900 dark:border-white transition duration-500 ease-in-out">
                        <switch-horizontal-icon class="text-gray-900 w-7 cursor-pointer dark:text-white transition duration-500 ease-in-out" @click="store.commit('switchRunner', {key, runner})" />
                    </div>
                </div>
            </div>
            <primary-cta title="Your Total Stake is 1 Token (£1)" @bet="showPlaceBetModal = true" :showAction="false" :showBetButton="!bettingDisabled" />
        </div>
        <alert v-else type="info">
            <template #title>
                Please select a horse from each race.
            </template>

            <template #message>
                In order to place your bet, you must select a horse from each race in this meeting.
            </template>
        </alert>
        <tw-modal :show="showPlaceBetModal" @close="showPlaceBetModal = false">
            <h2 class="text-center mt-2 mb-2 text-3xl font-semibold dark:text-racing-stars-yellow">Tokens Deposited</h2>
            <span class="text-center mb-2 block">1 Token (&pound;1)</span>

            <div class="grid grid-cols-2 mt-4">
                <div class="col-span-1">
                    <h3 class="text-center mb-2 text-1xl dark:text-racing-stars-yellow">Potential Daily Winnings</h3>
                    <span class="text-center mb-2 block">{{ formatter.format(page.props.value.racingstars.dailyJackpot / 100) }}</span>
                </div>
                <div class="col-span-1">
                    <h3 class="text-center mb-2 text-1xl dark:text-racing-stars-yellow">Potential Weekly Winnings</h3>
                    <span class="text-center mb-2 block">{{ formatter.format(page.props.value.racingstars.weeklyJackpot / 100) }}</span>
                </div>
            </div>
            <div class="text-center mt-4" v-if="meetingUnderway">
                Please be aware that this meeting is currently underway, so any bet you place will still use 1 token, and you won't be able to select horses from a race that has completed. Do you want to continue?
            </div>
            <div v-if="betForm.errors.meeting">{{ betForm.errors.meeting }}</div>
            <div v-if="betForm.errors.runners">{{ betForm.errors.runners }}</div>
            <div class="flex items-center justify-center mt-4">
                <tw-button :secondary="true" :sm="true" @click="showPlaceBetModal = false" class="mr-4">No</tw-button>
                <tw-button class="disabled:opacity-50 disabled:cursor-not-allowed" :disabled="betForm.processing" @click="placeBet">Place Bet</tw-button>
            </div>
        </tw-modal>
    </div>
</template>
<script>
import { ref, computed, getCurrentInstance } from 'vue'
import Alert from '@/Global/Alert.vue'
import { SwitchHorizontalIcon } from '@heroicons/vue/outline'
import { useStore } from 'vuex'
import { usePage } from '@inertiajs/inertia-vue3'
import TwButton from '@/Global/Elements/TwButton.vue'
import TwCard from '@/Global/Elements/TwCard.vue'
import TwModal from '@/Global/Elements/TwModal.vue'
import PrimaryCta from '@/Pages/Dashboard/Partials/PrimaryCta'
import moment from 'moment'
import { Inertia } from '@inertiajs/inertia'

export default {
    props: {
        runners: Object,
        user: Object,
    },

    setup(props) {

        const store = useStore()

        const page = usePage()


        /**
         * Inertia payment form.
         * 
         * @type {Reactive}
         */
        const betForm = Inertia.form({
            meeting_id: store.getters.races[0].meeting_id,
            runners: store.getters.selectedRunners
        })

        /**
         * Formatter function required to format currencies/prices correctly.
         * 
         * @type {Intl}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        const showPlaceBetModal = ref(false)

        const placeBet = () => {
            // axios.post(route('api.tutorial.set'), {
            //     tutorialStep: 0
            // })

            betForm.post('bets', {
                onSuccess: () => {
                    showPlaceBetModal.value = false

                    store.dispatch('resetPlayState')
                }
            })
        }

        const bettingDisabled = computed(() => {
            let raceCount = 0;

            props.runners.map(runner => {
                let index = props.runners.indexOf(runner);

                if (!moment(runner.race.starts_at).subtract(2, 'minutes').isAfter(moment())) {
                    if (index > -1) {
                        store.commit('removeRunner', {index, runner})
                    }
                }
            })

            store.getters.races.map(race => {
                if (moment(race.starts_at).subtract(2, 'minutes').isAfter(moment())) {
                    raceCount = raceCount + 1;
                }
            })

            return props.runners.length !== raceCount
        })

        const meetingUnderway = computed(() => {
            let underway = false

            store.getters.races.map(race => {
                if (race.results.length) {
                    underway = true;
                }
            })

            return underway
        })

        return {
            store,
            page,
            formatter,
            placeBet,
            bettingDisabled,
            meetingUnderway,
            showPlaceBetModal,
            betForm,
        }

    },

    components: {
        Alert,
        SwitchHorizontalIcon,
        TwButton,
        TwModal,
        TwCard,
        PrimaryCta,
        Inertia,
    }
}

</script>
